<template>
  <div>
    <header-component />

    <transition name="slide-left" mode="out-in">
      <side-bar-component />
    </transition>

    <main class="container-fluid" :class="{'menu-open':menuState=='open'}">

      <transition name="slide-left" mode="out-in">
        <router-view />
      </transition>

    </main>
  </div>
</template>

<script>
import headerComponent from "@/layouts/partials/TheAppHeader";
import sideBarComponent from "@/layouts/partials/TheAppSideBar";

export default {
  components: {
    sideBarComponent,
    headerComponent
  },


  computed: {
    menuState() {
      return this.$store.getters["menu/menuState"];
    }
  },

  

  methods: {}
};
</script>
<style lang="scss" scoped>
main {
  margin-top: 120px;
}

.menu-open {
}

@media (min-width: 992px) {
  .menu-open {
    padding-left: 276px;
  }
}
</style>
